export const FETCH_OBS_SCHEDULES = "app/OBS_SCHEDULE/FETCH_OBS_SCHEDULES";
export const FETCH_OBS_SCHEDULES_SUCCESS =
  "app/OBS_SCHEDULE/FETCH_OBS_SCHEDULES_SUCCESS";
export const FETCH_OBS_SCHEDULES_FAILURE =
  "app/OBS_SCHEDULE/FETCH_OBS_SCHEDULES_FAILURE";

export const ADD_OBS_SCHEDULE = "app/OBS_SCHEDULE/ADD_OBS_SCHEDULE";
export const ADD_OBS_SCHEDULE_SUCCESS =
  "app/OBS_SCHEDULE/ADD_OBS_SCHEDULE_SUCCESS";
export const ADD_OBS_SCHEDULE_FAILURE =
  "app/OBS_SCHEDULE/ADD_OBS_SCHEDULE_FAILURE";

export const EDIT_OBS_SCHEDULE = "app/OBS_SCHEDULE/EDIT_OBS_SCHEDULE";
export const EDIT_OBS_SCHEDULE_SUCCESS =
  "app/OBS_SCHEDULE/EDIT_OBS_SCHEDULE_SUCCESS";
export const EDIT_OBS_SCHEDULE_FAILURE =
  "app/OBS_SCHEDULE/EDIT_OBS_SCHEDULE_FAILURE";

export const DELETE_OBS_SCHEDULE = "app/OBS_SCHEDULE/DELETE_OBS_SCHEDULE";
export const DELETE_OBS_SCHEDULE_SUCCESS =
  "app/OBS_SCHEDULE/DELETE_OBS_SCHEDULE_SUCCESS";
export const DELETE_OBS_SCHEDULE_FAILURE =
  "app/OBS_SCHEDULE/DELETE_OBS_SCHEDULE_FAILURE";

export const TOGGLE_OBS_SCHEDULE = "app/OBS_SCHEDULE/TOGGLE_OBS_SCHEDULE";
export const TOGGLE_OBS_SCHEDULE_SUCCESS =
  "app/OBS_SCHEDULE/TOGGLE_OBS_SCHEDULE_SUCCESS";
export const TOGGLE_OBS_SCHEDULE_FAILURE =
  "app/OBS_SCHEDULE/TOGGLE_OBS_SCHEDULE_FAILURE";

export const FETCH_DUE_OBSERVATIONS = "app/OBS_SCHEDULE/FETCH_DUE_OBSERVATIONS";
export const FETCH_DUE_OBSERVATIONS_SUCCESS =
  "app/OBS_SCHEDULE/FETCH_DUE_OBSERVATIONS_SUCCESS";
export const FETCH_DUE_OBSERVATIONS_FAILURE =
  "app/OBS_SCHEDULE/FETCH_DUE_OBSERVATIONS_FAILURE";

export const FETCH_DUE_SUMMARY = "app/OBS_SCHEDULE/FETCH_DUE_SUMMARY";
export const FETCH_DUE_SUMMARY_SUCCESS =
  "app/OBS_SCHEDULE/FETCH_DUE_SUMMARY_SUCCESS";
export const FETCH_DUE_SUMMARY_FAILURE =
  "app/OBS_SCHEDULE/FETCH_DUE_SUMMARY_FAILURE";
